import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Manager } from '@shared/models';

import { managerGet, managerLoadSuccess } from './managers.action';

export interface ManagerState extends EntityState<Manager> {
  selectedId?: number;
  loading: boolean;
}

export const managersAdapter: EntityAdapter<Manager> = createEntityAdapter<Manager>({
  selectId: (manager: Manager) => manager.id,
  sortComparer: false,
});

export const initialState: ManagerState = managersAdapter.getInitialState({
  selectedId: null,
  loading: false,
});

const reducer = createReducer(
  initialState,
  on(managerLoadSuccess, (state, { manager }) =>
    managersAdapter.upsertOne(manager, {
      ...state,
      loading: false,
    }),
  ),
  on(managerGet, (state) => ({
    ...state,
    loading: true,
  })),
);

export function managersReducer(state: ManagerState, action: Action) {
  return reducer(state, action);
}
